module.exports = __webpack_public_path__ + "images/ca1cd74a3557d1bce7aaedc44321aae1.png";